module.exports = __webpack_public_path__ + "media/assets/icons/chevron-right2-e299f373367a38c6a344f9710767f945.svg";